import { useState, useEffect, useCallback } from "react";
import { useAlert } from "../../../../context/AlertContext";
import { Helmet } from "react-helmet-async";
import { useLocation, useNavigate } from "react-router-dom";
import { Card, Button, Col, Row, Container, Tabs, Tab } from "react-bootstrap";
import { useWebsiteName } from "../../../../context/WebsiteNameContext";
import CalendarComponent from "../../../../components/CalendarComponent";
import TechnicianPlansService from "../../../../services/technicianplan.service";
import {
  getServiceRequest,
  addEditServiceRequest
} from "../../../../commons/ServiceRequest";
import { getQueryString } from "../../../../utils/Query";
import moment from "moment";

export default function WorkCalendar() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { showAlert } = useAlert();
  const { websiteName, setWebsiteName } = useWebsiteName();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const pSetData = (vData) => {
    const colorMap = {};
    const newArray = vData.map((items) => {
      const title = items.Technician.Tech_Mas_Name;

      // Check if color is already assigned for this title
      if (!colorMap[title]) {
        colorMap[title] = getRandomHexColor(); //items.Technician.Tech_Mas_Code;//getRandomHexColor();
      }

      return {
        title: title,
        start: new Date(items.job_actual_date),
        end: new Date(items.job_actual_date),
        hexColor: colorMap[title]
      };
    });
    setData(newArray);
  };

  const getCalendarTechnician = (obj) => {
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: TechnicianPlansService.getTechnicianPlanningCalendar(
        getQueryString({
          plan_status: "NOT-OPEN",
          page: 1,
          limit: 1000,
          start: obj?.start?.toISOString(),
          end: obj?.end?.toISOString()
        })
      ),
      callback: (res) => {
        pSetData(res?.data);
      }
    });
  };
  useEffect(() => {
    const firstDayOfMonth = moment().startOf("month").toDate();
    const lastDayOfMonth = moment().endOf("month").toDate();
    getCalendarTechnician({
      start: firstDayOfMonth,
      end: lastDayOfMonth
    });
  }, []);

  return (
    <>
      <Container fluid className="p-0">
        <Card className="m-1 mb-4 p-4 border-0">
          <Card.Header className="p-3 pb-1 bg-transparent border-bottom-0">
            <Card.Title className="mb-0 fs-2 text-center">
              แผนงานของช่างปฎิบัติงาน
            </Card.Title>
          </Card.Header>

          <Card.Body>
            <CalendarComponent
              events={data}
              onRangeChange={(event) => {
                let start_time;
                let end_time;
                const is_array = Array.isArray(event);
                if (is_array) {
                  if (event?.length == 1) {
                    let startDate = new Date(event[0]);
                    let endDate = new Date(startDate);
                    endDate.setDate(endDate.getDate() + 1);
                    endDate.setHours(0, 0, 0, 0);
                    end_time = endDate;
                  } else {
                    end_time = event[6];
                  }
                  start_time = event[0];
                } else {
                  start_time = event?.start;
                  end_time = event?.end;
                }

                getCalendarTechnician({
                  start: start_time,
                  end: end_time
                });
              }}
            />
          </Card.Body>
        </Card>
        {/* <Row className="mt-3 text-center">
                console.log("🚀 ~ WorkCalendar ~ end_time:", end_time)
                console.log("🚀 ~ WorkCalendar ~ end_time:", end_time)
                console.log("🚀 ~ WorkCalendar ~ end_time:", end_time)
                <Col className="mt-3">
                  <Button
                    type="submit"
                    variant="outline-secondary"
                    className="me-2 px-5 py-2 text-dark rounded-pill"
                    onClick={() =>
                      navigate("/service_work/planning", {
                        state: "EventPlanning"
                      })
                    }
                  >
                    ย้อนกลับ
                  </Button>
                </Col>
              </Row> */}
      </Container>
    </>
  );
}

function getRandomHexColor() {
  const letters = "0123456789ABCDEF";
  let color = "#";

  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }

  return color;
}
